import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import MaterialRadio from '@material-ui/core/Radio';

const GreenRadio = withStyles({
	root: {
		color: '#5a3430',
		'&$checked': {
			color: '#5a3430',
		},
	},
	checked: {},
})((props) => <MaterialRadio color="default" {...props} />);

export default function Radio(props) {

	return (
		<GreenRadio {...props}/>
	);
}